var map = {
	"./Certicados/ReactCerti.png": 455,
	"./Certicados/ScrumCerti.png": 775,
	"./Certicados/aws-cloud-foundations.png": 760,
	"./Certicados/aws-machine-learning-foundations.png": 323,
	"./Certicados/certSpringBoot.png": 625,
	"./Certicados/cert_java_docker.jpg": 588,
	"./Certicados/dockerCerti.png": 922,
	"./Certicados/javaCertificado.jpg": 220,
	"./Certicados/reactNativeCerti.png": 191,
	"./Certicados/sqlCerti.png": 469,
	"./Certicados/unesplogo.png": 176,
	"./LI-In-Bug.png": 855,
	"./SpringApiHospital.png": 522,
	"./condadoFoto.png": 207,
	"./github-mark-white.png": 735,
	"./github-mark.png": 188,
	"./java-logo-1.png": 769,
	"./jogoWebSocket.png": 399,
	"./mongoDbWorkshop.png": 494,
	"./profile-pic.png": 359,
	"./react.png": 567,
	"./sol-poente.png": 776,
	"./sprinbootJpa.png": 721,
	"./spring.svg": 357,
	"./ts-logo-512.png": 782,
	"./ts-logo-512.svg": 39,
	"./workshop-java-jdbc.png": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 333;